module.exports = require('./helpers/bundle-url').getBundleURL('1DUm8') + "contract.a02eadc2.png";